if(window.innerWidth>750){
    var wFlag = true
}else{
    wFlag = false
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function autoPlayOnView(className, threshold = 0.5) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play();
          observer.unobserve(entry.target); // 播放一次后取消观察
        }
      });
    }, { threshold });
  
    elements.forEach(el => observer.observe(el));
}

$(()=>{
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 200);

    //box1_1
    ScrollTrigger.create({
        trigger:'.box1_1',
        start:'top center-=20%',
        end:'+=0%',
        // toggleActions:'play none none reverse',
        // scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box1_img1',{y:0})
            .to('.box1_img2',{y:0},'<')
            .from('.box1_text',{scale:0.5,opacity:0})
    })

    //box2
    showUp('.box2 div:nth-child(1) p')
    ScrollTrigger.create({
        trigger:'.box2',
        start:'top center-=10%',
        end:'+=100%',
        // toggleActions:'play none none reverse',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .from('.box2 div:nth-child(n+2)',{y:'2rem',opacity:0,stagger:0.2})
    })

    //box3
    showUp('.box3_title')
    // ScrollTrigger.create({
    //     trigger:'.box3_items',
    //     start:'top bottom-=20%',
    //     end:'+=40%',
    //     scrub:1,
    //     // markers:true,
    //     animation:gsap.timeline().to('.box3_items div',{xPercent:0,x:0,opacity:1})
    // })
    const $itemsBox = $('.box3 .box3_items');

    if(!wFlag){
        if ($itemsBox.length > 1) {
            const $target = $itemsBox.first();
    
            $itemsBox.slice(1).each(function () {
                $target.append($(this).contents());
                $(this).remove();
            });
        }
    }

    //box4
    var $video = $('#box4Video');

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=80%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                //$video[0].duration 2.9 6
                $video[0].currentTime = self.progress * 2.9;
                $('.box4_title').toggleClass('showup',$video[0].currentTime>2.7)
                $('.box4_tip').toggleClass('showup',$video[0].currentTime>2.7)
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top+=120% top+=4%',
            end:'+=80%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                $video[0].currentTime = 2.9 + self.progress * 3.1;
                $('.box4_title').toggleClass('showup',$video[0].currentTime<3.2)
                $('.box4_tip').toggleClass('showup',$video[0].currentTime<3.2)
                $('.box4_info').toggleClass('showup',$video[0].currentTime>4.5)
                $('.box4_text').toggleClass('showup',$video[0].currentTime>5.5)
            }
        })
            
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=220%',
            pin:true,
        })
    }else{
        showUp('.box4_title')
        showUp('.box4_text')
        autoPlayOnView('.box4_video1')
        autoPlayOnView('.box4_video2')
    }

    //box5
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=3%',
            end:'+=100%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box5_info',{opacity:0,stagger:0.2})
                .from('.box5_title',{opacity:0,y:'2rem'})
                .to({},{duration:0.4})
                .to('.box5_title div',{opacity:0})
                .to('.box5_title a',{opacity:1})
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=120% top+=3%',
            end:'+=60%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .to('.box5_content',{opacity:0})
                .to('#box5Video',{opacity:0,scale:10})
                .from('.box6',{opacity:0},'-=50%')
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=180% top+=3%',
            end:'+=50%',
            scrub:true,
            onUpdate: function (self) {
                $('#box6Video')[0].currentTime = self.progress * 2.4;
                $('.box6_content').toggleClass('showup',$('#box6Video')[0].currentTime>2)
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=3%',
            end:'+=250%',
            pin:true
        })
    }else{
        showUp('.box5_title')
        showUp('.box6_content div:first-child')
        autoPlayOnView('.box5_video2')
    }

    //box7
    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box7',
        start:'top+=15% top+=4%',
        end:'+=40%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline()
            .to('.box7_flag',{opacity:0})
            .from('.box7_items',{opacity:0})
    })
    ScrollTrigger.create({
        trigger:'.box7',
        start:'top top+=4%',
        end:'+=70%',
        pin:true,
    })

    //box8
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=3%',
        end:'+=80%',
        scrub:1,
        pin:true,
        // markers:true,
        animation:gsap.timeline()
            .from('.box8_img img:nth-child(2)',{opacity:0})
            .from('.box8_title',{opacity:0,y:'2rem'},'-=20%')
    })

    //box9
    showUp('.box9_title')
    ScrollTrigger.create({
        trigger:'.box9_items',
        start:'top bottom-=20%',
        end:'+=40%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline().to('.box9_items div',{x:0,opacity:1})
    })

    //box11
    showUp('.box11_title')

    //box14
    showUp('.box14_title')
    $('.box14_btn div').click(function(){
        var index = $(this).index()
        $('.box14_btn div').removeClass('box10_btnActive')
        $(this).addClass('box10_btnActive')
        $('.box14_img img').css({opacity:0})
        $(`.box14_img img:nth-child(${index+1})`).css({opacity:1})
        if(index==0){
            $('.box14_flag1').addClass('color_flag')
            $('.box14_flag span:first-child').show()
            $('.box14_flag span:last-child').hide()
        }else{
            $('.box14_flag1').removeClass('color_flag')
            $('.box14_flag span:last-child').show()
            $('.box14_flag span:first-child').hide()
        }
    })

    //box10
    showUp('.box10_title')
    $('.box10_btn div').click(function(){
        var index = $(this).index()+1
        $('.box10_btn div').removeClass('box10_btnActive')
        $(this).addClass('box10_btnActive')
        $('.box10_icon img').hide()
        $(`.box10_icon img:nth-child(${index})`).show()
    })    
    new Swiper('.box10Swiper', {
        slidesPerView: wFlag?5:3,
        centeredSlides: true,
        loop: true,
        autoplay:true
    })

    //box13
    showUp('.box13_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box13Swiper',
            start:'top bottom-=20%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline().to('.box13Swiper .swiper-slide',{x:0,opacity:1})
        })
        $('.box13_item').hover(function(){
            $('.box13_item video').each(function() {
                this.pause();
            });
            $(this).find('video')[0].play();
        })
    }else{
        new Swiper('.box13Swiper', {
            slidesPerView: 1.5,
            centeredSlides: true,
            autoplay:true,
            on:{
                slideChangeTransitionEnd: function(){
                    $('.box13_item video').css({filter:'brightness(0.4)'})
                    $('.box13_item video').each(function() {
                        this.pause();
                    });
                    $('.box13Swiper .swiper-slide-active .box13_item video').css({filter:'none'})
                    $('.box13Swiper .swiper-slide-active .box13_item video')[0].play()
                },
            },
        })
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    $('.box2 div').click(function(){
        var index = $(this).index()+1
        if(index == 2){
            var element = document.querySelector(".box5");
            element.scrollIntoView({block: "start"});
        }else if(index == 3){
            var element = document.querySelector(".box4");
            element.scrollIntoView({block: "start"});
        }else if(index == 4){
            var element = document.querySelector(".box7");
            element.scrollIntoView({block: "start"});
        }else if(index == 5){
            var element = document.querySelector(".box8");
            element.scrollIntoView({block: "start"});
        }else if(index == 6){
            var element = document.querySelector(".box10");
            element.scrollIntoView({block: "start"});
        }
    })

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/xlim-go-2'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})